import React, { useEffect } from 'react'

/**
 * Redireciona para a ficha em HTML puro (mesmo visual ERP).
 * Link público principal: /ficha-cadastral.html
 */
export default function FichaCadastral() {
  useEffect(() => {
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
    window.location.replace(`${base}/ficha-cadastral.html`)
  }, [])

  return (
    <p style={{ padding: '2rem', fontFamily: 'system-ui', color: '#273351' }}>
      Redirecionando para a ficha cadastral…
    </p>
  )
}
